import { Import } from "../models/Import";
import api from "./api";

const PATH = "/api/v1/imports";

export const ImportService = {
  async getAll(): Promise<Import[]> {
    const res = await api.get(PATH);
    return res.data.data;
  },

  async createFileImport(
    file: globalThis.File,
    matterId: string,
  ): Promise<void> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("matterId", matterId);
    const res = await api.post(`${PATH}/file`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data.data;
  },

  async createFilingImport(
    file: globalThis.File,
    matterId: string,
  ): Promise<void> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("matterId", matterId);
    const res = await api.post(`${PATH}/filing`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data.data;
  },
};
